export enum VLANMeta {
  MODEL = "vlan",
  PK = "id",
}

export enum VlanVid {
  UNTAGGED = 0,
}
